module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_all2",
    attrs: {
      "id": "manage"
    }
  }, [_c('div', {
    staticClass: "content_box outer_box"
  }, [_c('div', {
    staticClass: "n_box_l"
  }, [_c('ul', [_c('li', {
    class: {
      'on': _vm.choose_type == '帳號資訊'
    },
    on: {
      "click": function($event) {
        _vm.selectPage('帳號資訊')
      }
    }
  }, [_vm._v("帳號資訊")]), _vm._v(" "), _c('li', {
    class: {
      'on': _vm.choose_type == '變更聯絡人'
    },
    on: {
      "click": function($event) {
        _vm.selectPage('變更聯絡人')
      }
    }
  }, [_vm._v("變更聯絡人")]), _vm._v(" "), _c('li', {
    class: {
      'on': _vm.choose_type == '帳號展延申請'
    },
    on: {
      "click": function($event) {
        _vm.selectPage('帳號展延申請')
      }
    }
  }, [_vm._v("帳號展延申請")]), _vm._v(" "), _c('li', {
    class: {
      'on': _vm.choose_type == '變更密碼'
    },
    on: {
      "click": function($event) {
        _vm.selectPage('變更密碼')
      }
    }
  }, [_vm._v("變更密碼")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "n_box_r"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choose_type == '帳號資訊'),
      expression: "choose_type == '帳號資訊'"
    }]
  }, [_c('div', {
    staticClass: "list_box w100pa"
  }, [_c('div', {
    staticClass: "n_ta1"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("年度")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearuser.rocYear) + " 學年度")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("已展延年度")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearuser.lastRocYear) + " 學年度")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("系所")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearuser.unitName) + " " + _vm._s(_vm.showUnitType()))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("類別")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showTeamType()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "n_bar"
  }, [_vm._v("負責人 / 聯絡人")]), _vm._v(" "), _c('div', {
    staticClass: "n_ta1"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("姓名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearuser.contactName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("學號")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearuser.contactSchoolId))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("電話")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearuser.contactMobile))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearuser.contactEmail))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choose_type == '變更聯絡人'),
      expression: "choose_type == '變更聯絡人'"
    }]
  }, [_c('div', {
    staticClass: "list_box w100pa"
  }, [_c('div', {
    staticClass: "n_ta2"
  }, [_c('table', [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.contactName),
      expression: "recordToEdit.contactName"
    }],
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "contactName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.contactSchoolId),
      expression: "recordToEdit.contactSchoolId"
    }],
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.contactSchoolId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "contactSchoolId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.contactMobile),
      expression: "recordToEdit.contactMobile"
    }],
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.contactMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "contactMobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.contactEmail),
      expression: "recordToEdit.contactEmail"
    }],
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "contactEmail", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "psbox"
  }, [_vm._v("注意事項")]), _vm._v(" "), _c('div', {
    staticClass: "tomi mt15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agree1),
      expression: "agree1"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.agree1) ? _vm._i(_vm.agree1, "") > -1 : (_vm.agree1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agree1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agree1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agree1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agree1 = $$c
        }
      }
    }
  }), _vm._v(" 我已閱讀相關注意事項\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tomi mt15"
  }, [_c('button', {
    staticClass: "btn_m",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("送出修改")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choose_type == '帳號展延申請'),
      expression: "choose_type == '帳號展延申請'"
    }]
  }, [_c('div', {
    staticClass: "list_box w100pa"
  }, [_c('div', {
    staticClass: "n_ta1"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("原帳號年度")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearuser.rocYear) + "學年度")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("申請展延年度")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.nowRocYear) + " 學年度")])])])]), _vm._v(" "), _c('div', {
    staticClass: "psbox"
  }, [_vm._v("注意事項")]), _vm._v(" "), (!_vm.nowExtendApply) ? _c('div', [_c('div', {
    staticClass: "tomi mt15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agree2),
      expression: "agree2"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.agree2) ? _vm._i(_vm.agree2, "") > -1 : (_vm.agree2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agree2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agree2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agree2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agree2 = $$c
        }
      }
    }
  }), _vm._v(" 我已閱讀相關注意事項\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tomi mt15"
  }, [_c('button', {
    staticClass: "btn_m",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.saveExtend
    }
  }, [_vm._v("送出申請")])])]) : _c('div', [_vm._v("\n            審核狀態 " + _vm._s(_vm.showApplyStatus()) + "\n          ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choose_type == '變更密碼'),
      expression: "choose_type == '變更密碼'"
    }]
  }, [_c('div', {
    staticClass: "list_box w100pa"
  }, [_c('div', {
    staticClass: "mt5 mb5"
  }, [_vm._v("\n            帳號：　" + _vm._s(_vm.account) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mt5 mb5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": "輸入舊密碼"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt5 mb5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": "輸入新密碼"
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt5 mb5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    staticClass: "input_style",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": "再次輸入新密碼"
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt5 mb5"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": "6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"
    },
    on: {
      "verify": _vm.onVerify
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tomi mt15"
  }, [_c('button', {
    staticClass: "btn_m",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.savePassword
    }
  }, [_vm._v("送出")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "on",
    staticStyle: {
      "margin-top": "20px",
      "font-size": "16px",
      "text-align": "center",
      "font-weight": "bold"
    }
  }, [_vm._v("每年7/31前"), _c('br'), _vm._v("須申請展延")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_c('span', {
    staticClass: "note"
  }, [_vm._v("*")]), _vm._v("姓名")]), _vm._v(" "), _c('th', [_c('span', {
    staticClass: "note"
  }, [_vm._v("*")]), _vm._v("學號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_c('span', {
    staticClass: "note"
  }, [_vm._v("*")]), _vm._v("電話")]), _vm._v(" "), _c('th', [_c('span', {
    staticClass: "note"
  }, [_vm._v("*")]), _vm._v("Email")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-340cb60a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rent/Manage.vue
// module id = 1212
// module chunks = 3